module.exports = __webpack_public_path__ + "icons.1dc35d25e61d819a9c357074014867ab.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-css/themes/default/assets/fonts/icons.ttf
// module id = 32
// module chunks = 0